import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useIntegrationUsedByAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useIntegrationUsedByAnalytics;
